export const randoms = [
    "Beeline",
    "Anime",
    "Shadow",
    "Sword",
    "Fragment",
    "Keep Off The Grass",
    "Pygmy",
    "Artery",
    "Gruesome",
    "Summer",
    "Acrobatic",
    "Sign Language",
    "Bunch",
    "Hocus Pocus",
    "Tomato Ketchup",
    "Sanctuary",
    "Cosmetic",
    "Innocent",
    "Anorexia",
    "Beeline",
    "Alien",
];